module.exports = __webpack_public_path__ + "img/image46.dbda1c3b.png";